import { useSelector } from "react-redux";

export function useFunctionalityAccess(featureName) {
  const user = useSelector((state) => state.auth.user);
  return user?.role?.functionalityAccess?.[featureName] || false;
}
